import { render, staticRenderFns } from "./QualityAssuranceLabelDetails.vue?vue&type=template&id=59255bf1"
import script from "./QualityAssuranceLabelDetails.vue?vue&type=script&lang=js"
export * from "./QualityAssuranceLabelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports